<template>
  <div class="container-ctime">
    <van-popup :value="showPop" position="bottom" :style="{ height: '35%' }" @input="handlePopupInput" @close="closePop">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title=""
        :cancel-button-text="$t('lang.BaseCommon.k006')"
        :confirm-button-text="$t('lang.BaseCommon.k028')"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="confirm(currentDate)"
        @cancel="cancel(currentDate)"
      />
    </van-popup>
  </div>
</template>

<script>
// 这个是 （ 年 月 日 ） 格式
export default {
  props: {
    showPop: {
      default: false,
    },
    minDate: {
      type: Object | Date,
      default() {
        return new Date(2023, 0, 1)
      },
    },
    maxDate: {
      type: Object | Date,
      default() {
        return new Date()
      },
    },
  },
  data() {
    return {
      currentDate: new Date(),
      chooseTime: '',
    }
  },
  methods: {
    handlePopupInput(val) {
      if (!val) {
        this.closePop()
      }
    },
    confirm(time) {
      this.chooseTime = time
      this.closePop()
      this.$emit('handleCurrentDate', this.chooseTime)
    },
    cancel() {
      this.closePop()
    },
    closePop() {
      if (this.$parent && typeof this.$parent.closePop === 'function') {
        this.$parent.closePop()
      }
    },
  },
}
</script>
